import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//
import { Card, Button, Spinner } from "react-bootstrap";

import {
  createInvoice,
  createCeckoutID,
  createProductInvoice,
} from "../../../../redux/features/plan/actions";
import {
  changePlanModalMethod,
  changePlanModalStep,
} from "../../../../redux/features/plan/slice";
import { getUser } from "../../../../redux/features/user/actions";

//
import Coinbase from "../../../../assets/img/creditcard-geteways/Coinbase.svg";
import Stripe from "../../../../assets/img/creditcard-geteways/Stripe-logo.svg";
import Points from "../../../../assets/img/creditcard-geteways/Points.svg";

//
import American from "../../../../assets/img/creditcard-geteways/american-express.png";
import Discover from "../../../../assets/img/creditcard-geteways/discover.png";
import MasterCard from "../../../../assets/img/creditcard-geteways/mastercard.png";
import Visa from "../../../../assets/img/creditcard-geteways/visa.png";

//
import BTC from "../../../../assets/img/creditcard-geteways/btc.png";
import BCH from "../../../../assets/img/creditcard-geteways/bch.png";
import ETH from "../../../../assets/img/creditcard-geteways/eth.png";
import LTC from "../../../../assets/img/creditcard-geteways/ltc.png";
import DAI from "../../../../assets/img/creditcard-geteways/dai.png";
import DOGE from "../../../../assets/img/creditcard-geteways/doge.png";
import USDC from "../../../../assets/img/creditcard-geteways/usdc.png";

//
import CoinbaseCommerceButton from "react-coinbase-commerce";
import "react-coinbase-commerce/dist/coinbase-commerce-button.css";

function Methods({
  product = false,
  user,
  getUser,
  choosedPlan,
  tradingviewUsername,
  changePlanModalMethod,
  changePlanModalStep,
}) {
  const [loading, setLoading] = useState(false);
  const [showCoinbaseBTN, setShowCoinbaseBTN] = useState(false);
  const [coinbaseData, setCoinbaseData] = useState({});
  const [selectedMethod, setSelectedMethod] = useState("stripe");

  useEffect(async () => {
    if (selectedMethod === "coinbase") {
      // start loading
      setLoading(true);
      setShowCoinbaseBTN(false);

      // get checkout ID
      await createCeckoutID({
        name: user.name || user.email,
        description: `Buy ${product ? "Indicator" : "Plan"} ${
          choosedPlan.name
        }`,
        local_price: {
          amount: choosedPlan.discountCode
            ? choosedPlan.discountPrice.USD.priceWithDiscount
            : choosedPlan.price_usd,
          currency: "USD",
        },
        pricing_type: "fixed_price",
      }).then(async (res) => {
        if (res) {
          setCoinbaseData(res);

          // set variables
          let payType = "coinbase";
          let auto_renew = "inactive";
          let product_id = choosedPlan.id;
          let key = res.code;

          let content = {
            key,
            product_id,
          };
          if (!product) {
            content.auto_renew = auto_renew;
          } else {
            content.username = tradingviewUsername;
          }

          if (choosedPlan.discountCode) {
            content.coupon = choosedPlan.discountCode;
          }

          // request
          if (!product) {
            await createInvoice({ payType, content }).then((res) => {
              if (res) {
                setShowCoinbaseBTN(true);
              }
            });
          } else {
            await createProductInvoice({ payType, content }).then((res) => {
              if (res) {
                setShowCoinbaseBTN(true);
              }
            });
          }
        }
      });

      // stop loading
      setLoading(false);
    }
  }, [selectedMethod]);

  const pay = () => {
    if (selectedMethod === "point") {
      changePlanModalMethod(selectedMethod);
      changePlanModalStep(selectedMethod);
    }

    if (selectedMethod === "stripe") {
      // start loading
      setLoading(true);

      // set variables
      let payType = "stripe";
      let auto_renew = "active";
      let product_id = choosedPlan.id;

      let content = {
        product_id,
      };
      if (!product) {
        content.auto_renew = auto_renew;
      } else {
        content.username = tradingviewUsername;
      }

      if (choosedPlan.discountCode) {
        content.coupon = choosedPlan.discountCode;
      }

      if (!product) {
        createInvoice({ payType, content }).then((res) => {
          if (res) {
            setLoading(false);
            window.location = res;
          } else {
            setLoading(false);
          }
        });
      } else {
        createProductInvoice({ payType, content }).then((res) => {
          if (res) {
            setLoading(false);
            window.location = res;
          } else {
            setLoading(false);
          }
        });
      }
    }
  };

  const chargeSuccess = (e) => {
    console.log(e, "success");
    getUser();
  };

  const chargeFailed = (e) => {
    console.log(e, "failed");
    getUser();
  };

  const paymentDetected = (e) => {
    console.log(e, "detected");
  };

  const coinbaseClosed = () => {
    console.log("sjhbcd n");
  };

  return (
    <>
      <div className="methods">
        <Card
          className="item bordered pointer"
          onClick={() => setSelectedMethod("stripe")}
        >
          <Card.Body>
            <div className="img-name">
              <div>
                <img src={Stripe} alt="method image" />
                <div className="title-subject">
                  <p>Credit Card</p>
                  <p>
                    Support Debit, Mastercard, America Express, Visa and
                    Discover
                  </p>
                </div>
              </div>

              <div className="images-box">
                <img src={American} alt="ways" />
                <img src={Discover} alt="ways" />
                <img src={MasterCard} alt="ways" />
                <img src={Visa} alt="ways" />
              </div>
            </div>
            <span
              className={selectedMethod === "stripe" ? "active" : ""}
            ></span>
          </Card.Body>
        </Card>

        <Card
          className="item bordered pointer"
          onClick={() => setSelectedMethod("coinbase")}
        >
          <Card.Body>
            <div className="img-name">
              <div>
                <img src={Coinbase} alt="method image" />
                <div className="title-subject">
                  <p>Coinbase</p>
                  <p>We partnership with COINBASE for crypto coins payment </p>
                </div>
              </div>

              <div className="images-box">
                <img src={BTC} alt="ways" />
                <img src={BCH} alt="ways" />
                <img src={ETH} alt="ways" />
                <img src={LTC} alt="ways" />
                <img src={DAI} alt="ways" />
                <img src={DOGE} alt="ways" />
                <img src={USDC} alt="ways" />
              </div>
            </div>
            <span
              className={selectedMethod === "coinbase" ? "active" : ""}
            ></span>
          </Card.Body>
        </Card>

        {!!choosedPlan.price_point && (
          <Card
            className="item bordered pointer"
            onClick={() => setSelectedMethod("point")}
          >
            <Card.Body>
              <div className="img-name">
                <div>
                  <img src={Points} alt="method image" />
                  <div className="title-subject">
                    <p>Points</p>
                    <p>Use your points by reffering your friends to joins </p>
                  </div>
                </div>
              </div>
              <span
                className={selectedMethod === "point" ? "active" : ""}
              ></span>
            </Card.Body>
          </Card>
        )}
      </div>

      <Card className="box-alert bordered">
        <Card.Body>
          <i className="las la-info-circle"></i>
          Your payment changed will be applied for the next bill
        </Card.Body>
      </Card>

      <div className="actions">
        <div className="back" onClick={() => changePlanModalStep("invoice")}>
          Back
        </div>

        {selectedMethod === "coinbase" ? (
          <>
            {showCoinbaseBTN ? (
              <CoinbaseCommerceButton
                styled
                chargeId={coinbaseData.code}
                onChargeSuccess={chargeSuccess}
                onChargeFailure={chargeFailed}
                onPaymentDetected={paymentDetected}
                onModalClosed={() => coinbaseClosed()}
              />
            ) : (
              <Button variant="info" size="lg">
                Buy With Crypto
                {loading && (
                  <div className="spinner-holder">
                    <Spinner animation="border" variant="white" size="sm" />
                  </div>
                )}
              </Button>
            )}
          </>
        ) : (
          <Button variant="info" type="submit" size="lg" onClick={() => pay()}>
            Continue
            {loading && (
              <div className="spinner-holder">
                <Spinner animation="border" variant="white" size="sm" />
              </div>
            )}
          </Button>
        )}
      </div>
    </>
  );
}

Methods.propTypes = {
  tradingviewUsername: PropTypes.string.isRequired,
  choosedPlan: PropTypes.object.isRequired,
  changePlanModalMethod: PropTypes.func.isRequired,
  changePlanModalStep: PropTypes.func.isRequired,
  getUser: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  changePlanModalMethod,
  changePlanModalStep,
  getUser,
};

const mapStateToProps = (state) => ({
  choosedPlan: state.planReducer.choosedPlan,
  tradingviewUsername: state.planReducer.tradingviewUsername,
  user: state.userReducer.user,
});

export default connect(mapStateToProps, mapDispatchToProps)(Methods);
